import { create } from 'zustand';
import api from '../api/axios';

const setFavicon = (url) => {
  if (!url) return;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = url + '?t=' + Date.now();
};

const useSettingsStore = create((set, get) => ({
  appName: '',
  appSlogan: '',
  logoUrl: '',
  // Web push icin gereken ACIK anahtar - sunucuda VAPID tanimli degilse bos
  // gelir ve "Bildirimleri Ac" dugmesi hic cizilmez (bkz. BildirimIzniDugmesi).
  vapidPublicKey: '',
  loaded: false,

  fetchSettings: async () => {
    if (get().loaded) return;
    try {
      const res = await api.get('/settings/public');
      const logoUrl = res.data.app_logo || '';
      if (logoUrl) setFavicon(logoUrl);
      set({
        appName:  res.data.app_name  || 'Uygulama',
        appSlogan: res.data.app_slogan || '',
        logoUrl,
        vapidPublicKey: res.data.vapid_public_key || '',
        loaded: true,
      });
    } catch {
      set({ appName: 'Uygulama', loaded: true });
    }
  },

  setSettings: (data) => {
    const name = data.app_name || '';
    if (name) document.title = name + ' Yönetim Sistemi';
    if (data.app_logo) setFavicon(data.app_logo);
    set({ appName: name, appSlogan: data.app_slogan || '', logoUrl: data.app_logo || get().logoUrl });
  },
}));

export default useSettingsStore;
